import React, { useState } from "react";
import {
  SpreadsheetComponent, 
  SheetDirective, 
  SheetsDirective, 
  ColumnsDirective, 
  ColumnDirective, 
  RangesDirective, 
  RangeDirective,
  Save,
  Inject
} from "@syncfusion/ej2-react-spreadsheet";
import { Spin, Button, DatePicker } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { RangePicker } = DatePicker;

function InvoiceList(props) {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    let spreadsheet;
    

  function createdHandler() {
    //Applying cell formatting dynamically using cellFormat method.
    spreadsheet.cellFormat({ fontWeight: 'bold', backgroundColor: '#4b5366', color: '#ffffff', fontSize: '12pt' }, 'A1:F1');
    // Applying currency format to a range.
    spreadsheet.numberFormat('TJS # ##0.00', 'E2:E160000');
  };

  // Загрузка данных
  const handleLoadData = () => {
    if (!startDate || !endDate) {
      setTableData([]);
      return;
    }

    setLoading(true);
    const query = `?start=${startDate}&end=${endDate}`;

    fetch(`https://smartpay.tj/api/reports/rni/reestr${query}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + window.sessionStorage["access_token"]
      }
    })
      .then((response) => response.json())
      .then((data) => {
        setTableData(data.rows || []);
      })
      .catch((error) => {
        console.error("Ошибка при загрузке данных:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Обработка изменений дат
  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setStartDate(dates[0].format("YYYY-MM-DD"));
      const endPlusOne = dates[1].clone().add(1, "day").format("YYYY-MM-DD");
      setEndDate(endPlusOne);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  return (
    <div style={{ minHeight: 600 }}>

      {/* Выбор периода и кнопка */}
      <div className="mb-4">
        <RangePicker className="w-1/3 m-4" onChange={handleDateChange} />
        <Button
          type="primary"
          style={{ marginLeft: 8 }}
          onClick={handleLoadData}
        >
          Гирифтани маълумот
        </Button>
      </div>

      {loading ? (
        <Spin indicator={antIcon} />
      ) : tableData.length === 0 ? (
        <div className="w-full text-center text-slate-500">
          Барои намоиши феҳрист, давраро интихоб намоед.
        </div>
      ) : (
        <SpreadsheetComponent 
          ref={(ssObj) => { spreadsheet = ssObj; }}
          created={createdHandler.bind(this)}
          height={800}
          saveUrl="https://smartpay.tj/api/spreadsheet/save"
        >
          <SheetsDirective>
            <SheetDirective name="Феҳрист">
              {/* Указываем, что будем использовать data как DataSource */}
              <RangesDirective>
                <RangeDirective 
                  dataSource={tableData} 
                  startCell="A1" 
                  showFieldAsHeader={true} 
                />
              </RangesDirective>
              <ColumnsDirective>
                {/* Пример: задать ширину столбцов, если нужно */}
                <ColumnDirective width={90} />
                <ColumnDirective width={120} />
                <ColumnDirective width={160} />
                <ColumnDirective width={150} />
                <ColumnDirective width={90} />
                <ColumnDirective width={150} />
                {/* Можно добавить ещё ColumnDirective, если нужно конкретно настроить количество столбцов */}
              </ColumnsDirective>
            </SheetDirective>
          </SheetsDirective>
          
        </SpreadsheetComponent>
      )}
    </div>
  );
}

export default InvoiceList;
